import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TagFollowToggle extends Component {
  static propTypes = {
    active: PropTypes.bool,
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    active: false,
    onClick: null,
  }

  constructor(props) {
    super(props);
    this.state = { active: this.props.active };
  }

  handleClick = (e) => {
    e.preventDefault();
    const newActiveState = !this.state.active;

    $.ajax({ url: this.props.url, type: (newActiveState ? 'POST' : 'DELETE') });
    this.setState({ active: newActiveState });

    if (this.props.onClick) this.props.onClick(this.props.id);
  }

  render() {
    const cssClasses = `Tag ${this.state.active ? 'Tag--selected' : 'Tag--grey'}`;
    const customStyles = { cursor: 'pointer' };
    return (
      <span onClick={this.handleClick} className={cssClasses} style={customStyles}>
        {this.props.name}
      </span>
    );
  }
}
